import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfig} from '../app.config';
import 'rxjs/add/operator/map'
import {UserModel} from '../models/user';
import {LoginResponse} from 'app/models/response';

@Injectable()
export class AuthService {
  endpoint = '';

  constructor(private http: HttpClient, private config: AppConfig) {
    this.endpoint = config.getConfig('api_endpoint');
  }

  login(username: string, password: string) {
    return this.http.post<any>(this.endpoint + '/auth/login', { username: username, password: password})
      .map(response => {
        if (response && response.accessToken) {
          localStorage.setItem('currentUser', JSON.stringify( UserModel.create(response.user)));
          localStorage.setItem('token', response.accessToken);
          return response.data;
        }
        throw new Error( response.message );
      });
  }

  logout() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
  }
}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/services/auth.service.ts